import { postBrands } from '../api/postBrands';

export const setPostBrands = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await postBrands(params);
            
            alert('Сохранено')
          
            if (callback) {
                callback();
            }
        } catch(error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}